<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner whole">
        <div class="modal">
          <div class="tutorial">
            <div class="swiper mySwiper">
              <Swiper :pagination="{ el: '.swiper-pagination', type: 'bullets' }" :modules="[Pagination, Navigation]">
                <SwiperSlide>
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <div class="slide">
                        <img src="@/assets/static/images/tutorial/tutorial01.jpg" alt="sample" class="img-tutorial" />
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <div class="slide">
                        <img src="@/assets/static/images/tutorial/tutorial02.jpg" alt="sample" class="img-tutorial" />
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <div class="slide">
                        <img src="@/assets/static/images/tutorial/tutorial03.jpg" alt="sample" class="img-tutorial" />
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <div class="pagination-btn-wrap">
                  <div class="swiper-pagination">
                    <span class="swiper-pagination-current">1</span><span class="swiper-pagination-total">3</span>
                  </div>
                  <button class="btn-skip" @click="close">건너뛰기</button>
                </div>
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import store from '@/store';
import { onBeforeMount, onMounted } from 'vue';
import router from '@/router';
const emits = defineEmits(['close']);
const close = async () => {
  await store.dispatch('layout/removeAllModalComponent');
  await router.replace({ path: '/intro' });
};


</script>

<style scoped></style>
